import { Component } from '@angular/core';

@Component({
  selector: 'wl-layout-demo',
  standalone: true,
  imports: [],
  templateUrl: './layout-demo.component.html',
  styleUrl: './layout-demo.component.scss',
})
export class LayoutDemoComponent {}
